import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: localStorage.getItem("lang") || "en",
    lng: localStorage.getItem("lang") || "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
